// => Import React
import React from "react"
import { Helmet } from "react-helmet"

//> Recoil
import {
  RecoilRoot,

} from 'recoil'

//Import Style =>
import { layoutContainer } from './styles.module.scss'




// => Component
const Layout = ({ children = "Mise en page du site" }) => {



  return (
    <RecoilRoot>

      <div className={layoutContainer}>
        <Helmet>
          <link rel="stylesheet" href="/snipcart/snipcart.css" />
        </Helmet>
        {/* Contenu du site */}
        {children}
      </div>
    </RecoilRoot>
  )
}

export default Layout